import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import { appActions } from '../../../actions';

import AdminPageLayout from '../layout';
import ProfessionForm from '../profession-edit/form';

import PortalApi from '../../../services/PortalApi';
import Utils from '../../../services/Utils';

class ProfessionIndexPage extends React.PureComponent {
  state = {
    professions: [],
  }

  async componentDidMount() {
    this.props.finishLoading();
    await this.loadProfessions();
  }

  loadProfessions = async () => {
    const professions = await PortalApi.admin.getProfessions();
    this.setState({
      professions,
    });
  }

  renderProfessionList = () => {
    const { professions } = this.state;
    const columns = [
      {
        Header: '# ID',
        accessor: row => row.id.toString(),
        id: 'id',
        width: 100,
        Cell: ({ value: id }) => (
          <Link className="edit-link" to={`/admin/professions/${id}`}>
            {id}
          </Link>
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 500,
      },
      {
        Header: 'Name (Chinese)',
        accessor: 'name_chinese',
        width: 300,
      },
      {
        Header: 'Last Researched At',
        accessor: 'last_researched_at',
        width: 300,
      },
      {
        Header: 'Research Status',
        id: 'research_status_string',
        accessor: row => row.research_status.status_string,
        width: 500,
      },
    ];

    return (
      <div className="profession-list">
        <ReactTable
          data={professions}
          columns={columns}
          defaultPageSize={25}
          pageSizeOptions={[10, 25, 50, 100]}
          filterable
          defaultFilterMethod={Utils.reactTableFilterInsensitive}
        />
      </div>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <AdminPageLayout>
          <div className="main-content">
            { this.renderProfessionList() }
            <hr />
            <div className="create-profession">
              <h1>Create New Profession</h1>
              <ProfessionForm mode="create" />
            </div>
          </div>
        </AdminPageLayout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  finishLoading: () => dispatch(appActions.finishLoading()),
});

ProfessionIndexPage.propTypes = {
  finishLoading: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

const StyledProfessionIndexPage = styled(ProfessionIndexPage)`
  .profession-list {
    margin-bottom: 20px;
  }
`;

export default connect(
  null,
  mapDispatchToProps,
)(StyledProfessionIndexPage);
